import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Slide,
  Typography,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CustomModal = ({
  isOpen,
  onClose,
  title,
  body,
  actions,
  handleClose,
  isCloseCustom
}) => {
  // console.log("isOpen:", isOpen);

  return (
    <Dialog
      open={isOpen}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      className="rounded-full"
      PaperProps={{ style: { borderRadius: "2rem" } }}
    >
      <DialogTitle id="modal-title" className="text-center">
          {onClose && (
            <IconButton
            aria-label="close"
            onClick={onClose}
            style={{ position: "absolute", top: 10, right: 10 }}
          >
            <CloseIcon />
          </IconButton>
          )}

        <Typography
          variant="body2"
          component="div"
          lineHeight={2}
          fontWeight={"bold"}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>{body}</DialogContent>
      <DialogActions>{actions}</DialogActions>
    </Dialog>
  );
};

export default CustomModal;
